export const NETWORK_TYPE_CONSTS = {
  columbus: "columbus",
  local: "local",
} as const;

export type NetworkType = keyof typeof NETWORK_TYPE_CONSTS;
